<template>
  <div class="safari-card">
    <div class="safari-card__top">
      <button v-if="isClearable" @click="onCardDelete" type="button" class="safari-card__delete">
        <img src="@/assets/img/clear-small-gray-icon.svg" alt="">
      </button>
      <div class="safari-card__count">
        Day {{ orderNumber }} | {{ formatDate(data.date) }}
      </div>
      <div class="safari-card__info">
        <div v-if="data.type && data.type.name" class="status-tag" :style="{ 'backgroundColor': data.type.color }">
          {{ data.type.name }}
        </div>
        <div v-if="data.national_park" class="safari-card__name">{{ data.national_park.name }} <span
          v-if="data.national_park_area">({{ data.national_park_area.name }})</span></div>
      </div>
    </div>
  </div>
</template>

<script>
import { format, parseISO } from 'date-fns'

export default {
  name: 'AppSafariCard',
  props: {
    data: {
      type: Object,
      required: true
    },
    orderNumber: {
      type: Number,
      default: 1,
    },
    isClearable: {
      type: Boolean,
      default: true
    },
  },
  methods: {
    onCardDelete() {
      this.$emit('onCardDelete')
    },
    formatDate(date) {
      if (!date) return ''
      return format(parseISO(date), 'dd MMM')
    },
  }
}
</script>

<style scoped lang="sass">
.safari-card
  position: relative
  margin-bottom: 10px
  border: 1px solid #eaeaea
  border-radius: 10px
  background-color: #fff

.safari-card__top
  display: flex
  align-items: center
  gap: 12px
  padding: 12px 25px 12px 12px

.safari-card__bottom
  padding: 12px 25px 12px 12px
  border-top: 1px solid #e7e7e7

.safari-card__delete
  position: absolute
  top: 2px
  right: 2px
  padding: 10px
  line-height: 0

.safari-card__count
  display: flex
  align-items: center
  justify-content: center
  padding: 11px 10px 10px
  border-radius: 8px
  background-color: #eee
  color: #181818
  font-size: 12px
  font-weight: 600

.safari-card__name
  color: #000
  font-size: 14px
  font-weight: 600

.safari-card__early-late
  display: flex
  align-items: center
  gap: 30px
  margin-top: 5px

.safari-card__early
  display: flex
  align-items: center
  gap: 6px
  color: #439ad1

.safari-card__clients
  display: flex
  align-items: center
  gap: 20px
  margin-top: 10px
  padding: 12px 25px 12px 12px
  border-top: 1px solid #e7e7e7

.safari-card__client
  display: flex
  align-items: center
  gap: 10px

  span
    color: #5f5f5f
    font-size: 13px
    transform: translateY(1px)

.safari-card__info
  display: flex
  align-items: center
  gap: 10px

</style>